import React from 'react';
import moment from 'moment';
import { Badge, Button } from 'reactstrap';
import { FILTER_FIELDS, defaultFilter } from '../config';

const isSet = (value) => value !== '' && value !== undefined && value !== null;

const display = (field, value, refs) => {
  if (field.type === 'date') return moment(value).format('DD/MM/YYYY');
  if (field.type === 'select') {
    const option = field
      .options(refs)
      .find((item) => String(item.value) === String(value));
    return option ? option.label : value;
  }
  return value;
};

/**
 * One chip per applied filter, each removable; Reset returns to the tab's
 * default filter. Visible even when the filter panel is collapsed.
 */
const FilterChips = ({ tab, applied, refs, onChange }) => {
  const active = tab.filterFields.filter((key) => isSet(applied[key]));
  if (!active.length) return null;

  const remove = (key) =>
    onChange({
      ...applied,
      [key]: FILTER_FIELDS[key].type === 'date' ? undefined : '',
    });

  return (
    <div
      className="d-flex flex-wrap align-items-center mt-2"
      style={{ gap: '6px' }}
    >
      {active.map((key) => {
        const field = FILTER_FIELDS[key];
        return (
          <Badge
            key={key}
            color="light"
            pill
            className="border d-inline-flex align-items-center"
            style={{ fontSize: '13px', fontWeight: 400, padding: '4px 10px' }}
          >
            {field.label}: {display(field, applied[key], refs)}
            <button
              type="button"
              className="close ml-2"
              aria-label={`Remove ${field.label} filter`}
              style={{ fontSize: '16px', lineHeight: 1 }}
              onClick={() => remove(key)}
            >
              &times;
            </button>
          </Badge>
        );
      })}
      <Button
        color="link"
        size="sm"
        className="p-0 ml-1"
        onClick={() => onChange(defaultFilter(tab))}
      >
        Reset
      </Button>
    </div>
  );
};

export default FilterChips;
